export const isINN = (value: string) => {
    if (value.length === 10) {
        return isINN10(value);
    }
    if (value.length === 10) {
        return isINN12(value);
    }
    return false;
};

export const isINN10 = (value: string) => {
    if (/^\d{10}$/.test(value)) {
        const digits = value.split('').map(Number);
        if (
            digits[9] ===
            ((2 * digits[0] +
                4 * digits[1] +
                10 * digits[2] +
                3 * digits[3] +
                5 * digits[4] +
                9 * digits[5] +
                4 * digits[6] +
                6 * digits[7] +
                8 * digits[8]) %
                11) %
                10
        ) {
            return true;
        }
    }
    return false;
};

export const isINN12 = (value: string) => {
    if (/^\d{12}$/.test(value)) {
        const digits = value.split('').map(Number);
        if (
            digits[10] ===
                ((7 * digits[0] +
                    2 * digits[1] +
                    4 * digits[2] +
                    10 * digits[3] +
                    3 * digits[4] +
                    5 * digits[5] +
                    9 * digits[6] +
                    4 * digits[7] +
                    6 * digits[8] +
                    8 * digits[9]) %
                    11) %
                    10 &&
            digits[11] ===
                ((3 * digits[0] +
                    7 * digits[1] +
                    2 * digits[2] +
                    4 * digits[3] +
                    10 * digits[4] +
                    3 * digits[5] +
                    5 * digits[6] +
                    9 * digits[7] +
                    4 * digits[8] +
                    6 * digits[9] +
                    8 * digits[10]) %
                    11) %
                    10
        ) {
            return true;
        }
    }
    return false;
};
